import * as React from "react";
import usePluginEntities from "hooks/usePluginEntities";
import QueryValidation from "./QueryValidation";
const ViewsQueryValidation = () => {
  const viewsValidationExplanation = usePluginEntities("views.elements.validationErrorExplanation");
  return /* @__PURE__ */ React.createElement(QueryValidation, { validationExplanations: viewsValidationExplanation });
};
export default ViewsQueryValidation;
